export const isProFeaturesPlan = (planName: string) => planName === 'Pro';
